import { render, staticRenderFns } from "./rfq-statewide.vue?vue&type=template&id=f2c38bd2&scoped=true"
import script from "./rfq-statewide.vue?vue&type=script&lang=js"
export * from "./rfq-statewide.vue?vue&type=script&lang=js"
import style0 from "./rfq-statewide.vue?vue&type=style&index=0&id=f2c38bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c38bd2",
  null
  
)

export default component.exports